export interface Doctor {
  id: number;
  name: string;
  nameAr: string;
  email: string;
  phoneNumber: string;
  whatsApp: string;
  speciality: {
    id: number;
    label: string;
    image: string | null;
  };
  city: {
    id: number;
    name: string;
  };
  status: string;
  enterprises: any[];
  asstreinte: boolean;
  image: string;
}

export interface Language {
  id: number;
  name: string;
}

export interface DoctorProfile {
  id: number;
  etablishments: any[];
  association: string[];
  pubScientifique: string[];
  formations: string[];
  expertises: string[];
  presentation: string;
  language: string;
  languages: Language[];
  doctor: Doctor;
}

export interface DoctorResume {
  profiles: DoctorProfile[];
  canConsultOnline: boolean;
  canConsultOffice: boolean;
}

export interface DoctorResponse {
  content: Doctor[];
}

const API_BASE_URL = 'http://94.130.160.188:8090/patient-app/guest';

const fetchWithConfig = async (url: string) => {
  const config = {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    mode: 'cors' as RequestMode,
  };

  const response = await fetch(url, config);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const searchDoctors = async (query: string): Promise<Doctor[]> => {
  try {
    if (!query || query.trim().length < 2) {
      return [];
    }

    const url = `${API_BASE_URL}/doctors/?page=0&size=100&query=${encodeURIComponent(query.trim())}`;
    console.log('Fetching doctors from:', url);

    const data: DoctorResponse = await fetchWithConfig(url);
    console.log('Received doctors data:', data);

    if (!data || !data.content) {
      console.warn('Invalid response format:', data);
      return [];
    }

    return data.content;
  } catch (error) {
    console.error('Error in searchDoctors:', error);
    return [];
  }
};

export const getDoctorResume = async (doctorId: number): Promise<DoctorResume> => {
  try {
    if (!doctorId) {
      throw new Error('Doctor ID is required');
    }

    const url = `${API_BASE_URL}/doctor-resume/${doctorId}`;
    console.log('Fetching doctor resume from:', url);

    const data = await fetchWithConfig(url);
    console.log('Received doctor resume data:', data);
    
    if (!Array.isArray(data) || data.length === 0) {
      throw new Error('Invalid resume data format');
    }

    return data[0];
  } catch (error) {
    console.error('Error in getDoctorResume:', error);
    throw error;
  }
};
